<template>
	<div class="con">
		<div class="pay-title">
			<div>{{cardUserInfo.name}}</div>
		</div>	
		<div class="head" v-if="showNav == 1">
			<van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
				<van-tab title="待缴费"></van-tab>
				<van-tab title="已缴费"></van-tab>
			</van-tabs>
		</div>
		<!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="list.length != 0"> -->
		<div class="list">
			<div v-for="(item, index) in list" v-if="list.length > 0">
				<div class="list-con">
					<div class="list-con-top" >
						<div>
							<div class="title">{{item.KSMC}}</div>
							<div class="serial-number">挂号序号：{{item.GHXH}}</div>
							<div class="time-disp">
								<div class="time-text">挂号日期：{{item.KSSJ}}</div>
							</div>
							<div class="time-disp">
								<div class="time-text">结算时间：{{item.KSSJ}}</div>
							</div>
						</div>
						<div @click="showQrCodeShow(item.FPHM)">二维码</div>
					</div>
					<div class="list-con-right">
						<div></div>
						<div class="price" @click="showBtn(index)">
							<div><span>￥</span>{{item.total}}</div>
							<van-icon name="arrow" color="#ccc" v-if="!item.showState" />
							<van-icon name="arrow-down" color="#ccc" v-else />
						</div>
					</div>
					
				</div>
				<div class="show-box" v-show="item.showState">
					<div v-for="(d, i) in item.d" @click="showBtnClass(index, i)">
						<div class="show-disp">
							<div style="font-size: 14px;width: 80%;">{{d.SFMC}}</div>
							<div style="display: flex;">
								<div class="price"><span>￥</span>{{d.detailTotal}}</div>
								<van-icon name="arrow" color="#ccc" v-if="!d.showStateClass" />
								<van-icon name="arrow-down" color="#ccc" v-else />
							</div>
						</div>
						<div class="show-disp" v-for="(data, deIndex) in d.detail" v-show="d.showStateClass">
							<div class="medicines">
								<div>{{data.FYMC}}</div>
								<div>医生：{{data.YGXM}}</div>
								<div class="time-disp">
									<van-icon name="underway-o" color="#27BEC4" />
									<div class="time-text">{{data.KSSJ}}</div>
								</div>
							</div>
							<div class="show-disp-right">
								<div class="box-num">x{{data.XMSL}}</div>
								<div class="box-unit-price"><span>￥</span>{{data.ZJJE}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div class="shut-card-list" @click="qrCodeShutBtn" v-if="qrCodeShow">
				<van-icon name="cross" color="#fff" size="24px"/>
			</div>
			<div class="backCCC" v-if="qrCodeShow"></div>
			<div class="get-card-list" v-if="qrCodeShow">
				<div class="qr-text">取药或抽血时请出示该二维码</div>
				<img :src="qrCode" alt=""/>
			</div>
			
		<!-- </van-list> -->
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无缴费记录~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'paymentRecordsList',
		data() {
			return {
				msg: '缴费记录',
				cardUserInfo: {},
				headActive: 1,
				list: [],
				loading: false, //是否处于加载状态
				finished: false, //是否已加载完所有数据
				noImgShow: false,
				page: 1,
				qrCodeShow: false,
				qrCode: '',
				showNav: 0,
			}
		},
		methods: {
			//关闭二维码显示
			qrCodeShutBtn(){
				this.qrCodeShow = false
			},
			showQrCodeShow(e){
				this.qrCode = '';
				this.qrCodeShow = true
				this.$store.commit('Load', true)
				this.$Axios.Get('/outpatient/getOutFyQR?fphm=' + e, null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0){
						this.qrCode = res.msg
					}
				})
				.catch(err => {
					this.$store.commit('Load', false)
					this.$toast("网络出错")
					console.log(err)
				})
				
			},
			onLoad() {
				console.log('上拉加载')
				//				this.loading = true;
				this.finished = false;
				this.GetMzPayList()
			},
			//查询门诊缴费记录
			GetMzPayList() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/outpatient/getOutFy?brid=' + this.cardUserInfo.brid + '&type=2',
					null).then(res => {
						this.$store.commit('Load', false)
					console.log(res)
					if (res.code == 0) {
						if (res.msg.length != 0) {
							let dataList = res.msg;
							let newArr = JSON.parse(JSON.stringify(dataList));
							let newClassified = JSON.parse(JSON.stringify(dataList));
							
							//根据挂号序号GHXH分总
							for (let i = 0; i < newArr.length; i++) {
								newArr[i].showState = false;
								let total = 0;
								for (let j = i + 1; j < newArr.length;) {
							
									if (newArr[i].GHXH == newArr[j].GHXH) {
										total += Number(newArr[j].ZJJE);
										newArr.splice(j, 1)
									} else {
										j++;
									}
								}
								total += Number(newArr[i].ZJJE);
								newArr[i].total = total.toFixed(2);
							}
							for (let i = 0; i < newArr.length; i++) {
								let s = [];
								
								for (let j = 0; j < newClassified.length; j++) {
									if(newArr[i].GHXH == newClassified[j].GHXH) {
										s.push(newClassified[j])
									}
								}
								
								for (let k = 0; k < s.length; k++) {
									s[k].showStateClass = false;
									
										for (let j = k + 1; j < s.length;) {
											if (s[k].SFMC == s[j].SFMC) {
												s.splice(j, 1)
												
											} else {
												j++;
											}
										}
									
								}
								
								newArr[i].d = s;
							}
							
							for (let i = 0; i < newArr.length; i++) {
								let dArr = newArr[i].d;
								for (let j = 0; j < dArr.length; j++) {
									let sa = [];
									let sn = 0;
									for(let k = 0; k < dataList.length; k++){
										if(dArr[j].GHXH == dataList[k].GHXH && dArr[j].SFMC == dataList[k].SFMC){
											sn += Number(dataList[k].ZJJE);
											sa.push(dataList[k])
										}
									}
									dArr[j].detailTotal = sn.toFixed(2);
									dArr[j].detail = sa;
								}
							}
							
							
							this.list = newArr;
							console.log(newArr)
							return
							
							//挂号一样，分药类型SFMC
							for (let k = 0; k < newArr.length; k++) {
								for (let i = 0; i < newClassified.length; i++) {
									newClassified[i].showStateClass = false;
									
									if (newArr[k].GHXH == newClassified[i].GHXH) {
										for (let j = i + 1; j < newClassified.length;) {
											if (newClassified[i].SFMC == newClassified[j].SFMC) {
												newClassified.splice(j, 1)
											} else {
												j++;
											}
										}
									}
									
								}
							}
							
							for (let k = 0; k < newClassified.length; k++) {
								let s = [];
								let n = 0;
								
								for (let j = 0; j < dataList.length; j++) {
									if(newClassified[k].GHXH == dataList[j].GHXH && newClassified[k].SFMC == dataList[j].SFMC) {
										n += Number(dataList[j].ZJJE);
										s.push(dataList[j])
									}
									// if (newClassified[k].SFMC == dataList[j].SFMC) {
									// 	n += Number(dataList[j].ZJJE);
									// 	s.push(dataList[j])
									// }
								}
								
								newClassified[k].detail = s;
								newClassified[k].detailTotal = n.toFixed(2);
							}
							for (let j = 0; j < newClassified.length; j++) {
								console.log(newClassified[j].SFMC)
								console.log(newClassified[j].GHXH)
							}
							
							
							for (let k = 0; k < newArr.length; k++) {
								let s = []
								for (let j = 0; j < newClassified.length; j++) {
									
									if(newArr[k].GHXH == newClassified[j].GHXH){
										s.push(newClassified[j])
									}
								}
								console.log(s)
								newArr[k].d = s;
							}
							
							this.list = newArr;
							console.log(newArr)
							
							this.noImgShow = false;
							this.finished = true;
						} else {
							this.noImgShow = true;
							this.finished = true;
						}

					} else {
						this.noImgShow = true;
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					this.$toast("网络出错")
					this.noImgShow = true;
					console.log(err)
				})
			},
			//显示隐藏详情
			showBtn(e) {
				let listData = this.list;
			
				listData[e].showState = !listData[e].showState;
				this.list = listData;
			},
			showBtnClass(index, i) {
				let listData = this.list;
			
				listData[index].d[i].showStateClass = !listData[index].d[i].showStateClass;
				this.list = listData;
			},
			//顶部导航
			headBtn(e) {
				if(e == 0){
					this.$router.replace({
						path: '/payCost',
					})
				}
			}
			
		},
		mounted() {
			if (localStorage.getItem('cardUserInfo') != undefined) {
				this.cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'));
				console.log(JSON.parse(localStorage.getItem('cardUserInfo')))
			}
			this.GetMzPayList()
		},
		created() {
			this.showNav = this.$route.query.type
		},
	}
</script>

<style scoped>
	.con {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
	}
.pay-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}
	.list {
		flex: 1;
		overflow-y: scroll;
	}
	
	.list-con {
		padding: 20px;
		margin-bottom: 5px;
		font-size: 14px;
		background: #fff;
	}
	
	.list-info {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.title{
		color: #000000;
		font-weight: 700;
		font-size: 18px;
	}
	.text {
		font-size: 17px;
		font-weight: 500;
		color: #000;
	}
	
	.price {
		font-size: 18px;
		color: #FF0000;
	}
	
	.list-time {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}
	
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	
	.list {
		flex: 1;
		overflow-y: auto;
	}
	
	.list-con-top {
		display: flex;
		justify-content: space-between;
	}
	
	.time-disp {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}
	
	
	.price {
		display: flex;
		align-items: center;
		color: #FF0000;
		font-size: 18px;
		font-weight: 700;
	}
	
	.price span {
		font-weight: 500;
		font-size: 12px;
	}
	
	.total {
		display: flex;
		font-size: 15px;
	}
	
	.total div {
		padding: 20px 0;
		width: 50%;
		text-align: center;
	}
	
	.combined {
		background-color: #fff;
	}
	
	.combined span {
		color: #FF0000;
		font-size: 18px;
	}
	
	.pay-btn {
		background-color: #27BEC4;
		color: #fff;
	}
	
	
	.show-box {
		padding: 10px;
		margin: 0 auto 10px;
		width: 85%;
		background-color: #fff;
	}
	
	.show-disp {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
	}
	
	.medicines {
		width: 75%;
		color: #666;
		font-size: 14px;
	}
	
	.box-unit-price {
		font-size: 14px;
		color: #FF0000;
		font-weight: 700;
	}
	
	.box-unit-price span {
		font-weight: 500;
		font-size: 12px;
	}
	
	.box-num {
		text-align: end;
	}
	.list-con-right{
		display: flex;
		justify-content: space-between;
	}
	.shut-card-list{
		padding: 10px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 20px;
		margin: auto;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background-color: #FF0000;
		z-index: 10;
	}
	.backCCC{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #ccc;
		opacity: .5;
		z-index: 5;
	}
	.get-card-list{
		padding: 10px;
		position: absolute;
		top: 100px;
		left: 0;
		right: 0;
		width: 80%;
		height: 50%;
		margin: auto;
		background-color: #fff;
		z-index: 10;
		border-radius: 8px;
		text-align: center;
	}
	.get-card-list img{
		width: 90%;
		height: 90%;
	}
	.qr-text{
		font-size: 18px;
		color: #999;
		
	}
</style>
